<template>
  <div class="row">

    <div class="col-12">
      <page-header
        left-side-class="col-8"
        right-side-class="col-4 d-flex align-items-center"
        :actions="headerActionsConfig"
        :page="headerConfig"
      />
    </div>
    <div class="col-12">
      <filter-manager
        v-model="filters"
        :filters="filterConfig"
        @search="filterSearchHandler"
        @serviceType="onChangeServiceType"
      />
    </div>
    <div class="col-12">
      <custom-separator class="my-4" text="Resultado de Solicitud" />
      <custom-result-not-found v-if="resultsEmpty" />
      <div v-for="(row, i) of results" :key="`result-${i}`">
        <request-service-result
          :data="row"
          :blog-comment-types="blogCommentTypes"
          @on-get-determination-letter="onGetDeterminationLetterHandler(row)"
          @on-get-request-service-report="onGetRequestReportHandler(row)"
          @on-open-change-status="
            (status, serviceType) =>
              onOpenChangeStatusHandler(status, serviceType, i, row)
          "
          @on-open-close="onOpenCloseHandler(i, row)"
          @on-open-contract-history="
            onOpenContractHistoryHandler(i, row, $event)
          "
          @on-open-request-document="
            onOpenRequestDocumentHandler(i, row, $event)
          "
          @on-open-bitacora-addblog="
            onOpenBitacoraAddBlogHandler(i, row, $event)
          "
          @on-open-return-to-previous-status="
            onOpenReturnToPreviousStatusHandler(i, row)
          "
          @on-open-status-history="onOpenStatusHistoryHandler(i, row)"
          @on-open-bitacora-history="onOpenBitacoraHistoryHandler(i, row)"
          @on-open-view-determination="
            (status, serviceType) =>
              onOpenChangeStatusHandler(status, serviceType, i, row)
          "
          @on-refresh="onSearchHandler"
          @on-save-determination="onSaveDeterminationHandler($event, i)"
          @on-status-history-load-more="onStatusHistoryLoadMoreHandler(i, row)"
          @on-view-request="onViewRequestHandler(row)"
          @removed="onSearchHandler"
          @save-blog-item="handleSaveBlogItem"
        />
        <div
          v-if="row.appointmentId && !row.isOpen"
          class="alert alert-container p-2 rounded mb-3 py-2"
        >
          <div class="d-flex align-items-center">
            <em
              class="
                fa fa-bell-exclamation
                font-16
                pl-2
                ml-1
              "
            />
            <div class="font-14 font-weight-normal ml-3">
              {{ appointmentMessage(row) }}
            </div>
          </div>
        </div>
      </div>
      <pagination
        v-if="showPagination"
        :data="pagination"
        show-text
        @pagination-go-page="goToPage"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Pagination from 'pagination';
import FilterManager from 'FilterManager';
import RequestStatuses from '@/utils/constants/rp/rpStatuses.js';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import {
  getRemedyFilters,
  getRequestServices,
  getRpStatusHistory as _getRpStatusHistory,
  getDeterminationReasons,
  getRpRequestDocuments as _getRpRequestDocuments,
  getDeterminationLetterReport as _getDeterminationLetterReport,
  getRequestReport as _getRequestReport,
  getRequestServicesReport as _getRequestServicesReport,
} from '@/modules/student-answer-rp/api.js';
import codeServices from '@/modules/common/code.api.js';
import generalApi from '@/services/pei/general.js';
import { RequestServiceResult } from './components';
import requestHistoryViewDisplay from '@/utils/constants/rp/requestHistoryViewDisplay.js';
import serviceStatuses from '@/utils/constants/student/provisionalRemedyAnswerStatus.js';
import loadingMixin from '@quisit/mipe-utils/mixins/loading';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import { getBlogCommentTypes, addBlogItem, getBitacoraItems } from "@/modules/referral/api";

const DEFAULT_HISTORY_STATUS_PAGE_SIZE = 3;
const CANCELADA= 4;

export default {
  name: 'ProvRemedyReqManagment',
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    RequestServiceResult,
  },
  mixins: [alertMixin, loadingMixin],
  data() {
    return {
      results: [],
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
        pageSize: 20,
      },
      filterOptions: {
        academicYears: [],
        serviceStatuses: [],
        servicesTypes: [],
        disciplineTypes: [],
        centers: [],
        municipalities: [],
        regions: [],
        schools: [],
        reasons:[],
        reconsideration: [],
      },
      filters: {
        academicYear: null,
        serviceStatus: null,
        sieOrSolicitude: null,
        printingApproval: null,
        serviceType: null,
        disciplineType: null,
        registerNumber: null,
        applicantName: null,
        studentName: null,
        center: null,
        municipality: null,
        region: null,
        school: null,
        reason:null,
        reconsideration: null,
      },
      reasons: {},
      blogCommentTypes: [],
    };
  },
  async mounted() {
    await this.fetchBlogCommentTypes();
    await this.getFilters();
    await this.onSearchHandler();
  },
  computed: {
    headerConfig() {
      return {
        icon: 'fas fa-user-circle',
        title: 'Contestación de Remedio Provisional',
        routes: [
          'Inicio',
          'Estudiantes',
          'Contestación de Remedio Provisional',
          'Informaciones sobre las solicitudes',
        ],
      };
    },
    headerActionsConfig() {
      return [
        {
          text: 'Imprimir',
          icon: 'fas fa-print fa-lg mr-1',
          variant: 'outline-success',
          visible: this.hasGetRequestServiceReportPermission,
          click: () => this.onPrintHandler(),
        },
      ];
    },
    filterConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filterOptions.academicYears,
          value: this.filters.academicYear,
          placeholder: 'Año Académico',
          fieldName: 'name',
          fieldKey: 'id',
          class: this.isCancel ? 'col-12 col-md-2' : 'col-12 col-md-4',
          onChanged: this.fetchCenters,
        },
        {
          name: 'serviceStatus',
          component: 'CustomDropDown',
          options: this.filterOptions.serviceStatuses,
          value: this.filters.serviceStatus,
          placeholder: 'Estatus de Servicio',
          fieldName: 'name',
          fieldKey: 'id',
          class: this.isCancel ? 'col-12 col-md-2' : 'col-12 col-md-4',
        },
         {
          name: 'reason',
          component: 'CustomDropDown',
          options: this.filterOptions.reasons,
          value: this.filters.reason,
          placeholder: 'Razón',
          fieldName: 'name',
          visible:this.isCancel,
          fieldKey: 'id',
          class: 'col-12 col-md-4',
        },
        {
          name: 'sieOrSolicitude',
          component: 'CustomInput',
          placeholder: 'Escriba Número de SIE o Solicitud',
          value: this.filters.sieOrSolicitude,
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-md-4',
          maskType: 'SieOrSolicitude',
        },
        {
          name: 'center',
          component: 'CustomDropDown',
          options: this.filterOptions.centers,
          value: this.filters.center,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3',
          isAdvanced: true,
          label: 'Centro:',
          onChanged: this.onCenterChanged,
          disabled: this.filterOptions.centers.length == 1,
        },
        {
          name: 'municipality',
          component: 'CustomDropDown',
          options: this.filterOptions.municipalities,
          value: this.filters.municipality,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-3',
          isAdvanced: true,
          label: 'Municipio:',
          onChanged: this.onMunicipalityChanged,
          disabled: this.filterOptions.municipalities.length == 1,
        },
        {
          name: 'school',
          component: 'CustomDropDown',
          options: this.filterOptions.schools,
          value: this.filters.school,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-4',
          isAdvanced: true,
          label: 'Escuela:',
          disabled: this.filterOptions.schools.length == 1,
        },
        {
          name: 'serviceType',
          component: 'CustomDropDown',
          options: this.filterOptions.servicesTypes,
          value: this.filters.serviceType,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-2',
          isAdvanced: true,
          label: 'Servicio:',
        },
          {
          name: 'reconsideration',
          component: 'CustomDropDown',
          options: this.filterOptions.reconsideration,
          value: this.filters.reconsideration,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-2',
          isAdvanced: true,
          label: 'Reconsideración:',
        },
        {
          name: 'disciplineType',
          component: 'CustomDropDown',
          options: this.filterOptions.disciplineTypes,
          value: this.filters.disciplineType,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-2',
          isAdvanced: true,
          label: 'Disciplina:',
        },
        {
          name: 'registerNumber',
          component: 'CustomInput',
          value: this.filters.registerNumber,
          placeholder: 'Escriba Número de Registro',
          label: 'Número de Registro:',
          isAdvanced: true,
        },
        {
          name: 'applicantName',
          component: 'CustomInput',
          placeholder: 'Escriba Nombre de Solicitante',
          value: this.filters.applicantName,
          label: 'Nombre de Solicitante:',
          isAdvanced: true,
        },
        {
          name: 'studentName',
          component: 'CustomInput',
          placeholder: 'Escriba Nombre de Estudiante',
          value: this.filters.studentName,
          label: 'Nombre de Estudiante:',
          isAdvanced: true,
        },
      ];
    },
    currentAcademicYearId() {
      return this.currentAcademicYear().id;
    },
    isNewRequestStatusSelected() {
      if (!this.filters.serviceStatus) return false;
      return this.filters.serviceStatus.id === RequestStatuses.New;
    },
    resultsEmpty() {
      return this.results.length === 0;
    },
    isCancel(){
     return this.filters.serviceStatus?.id==CANCELADA
    },
    getFilterValues() {
      return {
        academicYearId: this.filters.academicYear?.id,
        serviceStatusId: this.filters.serviceStatus?.id,
        reasonId: this.isCancel ? this.filters.reason?.id : null,
        isReconsideration: this.filters.reconsideration?.value,
        studentSieIdOrRequestNumber: this.filters.sieOrSolicitude
          ?.trim()
          ?.toLocaleLowerCase(),
        approvedForPrinting:
          this.filters.printingApproval?.id == null
            ? null
            : this.filters.printingApproval?.id === 1
            ? true
            : false,
        serviceTypeId: this.filters.serviceType?.id,
        disciplineTypeId: this.filters.disciplineType?.id,
        registerNumber: this.filters.registerNumber
          ?.trim()
          ?.toLocaleLowerCase(),
        applicantName: this.filters.applicantName?.trim()?.toLocaleLowerCase(),
        studentName: this.filters.studentName?.trim()?.toLocaleLowerCase(),
        centerId: this.filters.center?.id,
        municipalityId: this.filters.municipality?.id,
        schoolId: this.filters.school?.id,
      };
    },
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.pageSize;
    },
    appointmentFormat() {
      return (appointmentId) =>
        this.$options.filters.appointmentFormat(appointmentId.toString());
    },
    appointmentMessage() {
      return (row) =>
        `El servicio ${
          row.serviceDiscipline
        } cuenta con una cita coordinada ${this.appointmentFormat(
          row.appointmentId
        )}.`;
    },
    hasGetRequestServiceReportPermission() {
      return this.userHasPermissions(
        'menu.rempro.requestservice.view.printreport'
      );
    },
  },
  methods: {
    async handleSaveBlogItem(data) {
      try {
        const formData = new FormData();
        formData.append('comment', data.comment);
        formData.append('commentTypeId', data.commentTypeId);
        formData.append('fileAlias', data.fileAlias);
        formData.append('file', data.file);

        await addBlogItem(data.requestServiceId, formData);
        this.ShowToast(
          '',
          'Elemento agregado a la bitácora correctamente.',
          'success'
        );
      } catch (err) {
        this.ShowToast(
          'Alerta',
          'Ocurrio un error al agregar un nuevo elemento a la bitácora.',
          'error'
        );
      }
    },
    async fetchBlogCommentTypes() {
      const { data } = await getBlogCommentTypes();
      this.blogCommentTypes = data;
    },
    async getFilters() {
      this.getCancelReason()
      const { data } = await getRemedyFilters();
      this.filterOptions = {
        ...data.collections,
        disciplineTypes: [],
        centers: [],
        municipalities: [],
        regions: [],
        schools: [],
      };
       this.filterOptions.reconsideration = [
        {
          value: true,
          name: 'Si',
        },
        {
          value: false,
          name: 'No',
        },
      ];
        this.getCancelReason()
      this.filters.academicYear = this.filterOptions.academicYears.find(
        (x) => x.id === this.currentAcademicYearId
      );
      await this.fetchCenters();
    },
    async  getCancelReason(){
     const { data } = await getDeterminationReasons(4,2) 
     this.filterOptions.reasons= data
    },
    async onChangeServiceType(item) {
      if (item) {
        this.filterOptions.disciplineTypes = await codeServices.getDisciplineTypes(
          {
            serviceTypeIds: [item.id]
          }
        );
      }
      this.filters.disciplineType = null;
    },
    async goToPage(page) {
      this.pagination.currentPage = page;
      await this.onSearchHandler();
    },
    async filterSearchHandler() {
      this.pagination.currentPage = 1;
      this.onSearchHandler();
    },
    async onSearchHandler() {
        if (!this.isCancel) {
        this.filters.reason = null;
      }
      const params = { ...this.getFilterValues };
      const { data } = await getRequestServices(
        params,
        this.pagination.currentPage,
        this.pagination.pageSize
      );
      this.results = (data.data ?? []).map((m) => ({
        ...m,
        serviceStatusHistory: [],
        serviceContractHistory: [],
        requestDocument: [],
      }));
      this.pagination = {
        ...this.pagination,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async getRpStatusHistory(requestServiceId, pageIndex, pageSize = 3) {
      return (await _getRpStatusHistory(requestServiceId, pageIndex, pageSize))
        .data;
    },
    setActiveViewDisplay(viewDisplay, index, prop) {
      this.results = this.results.map((x, idx) => ({
        ...x,
        isOpen: idx === index,
        viewToDisplay:
          idx === index ? viewDisplay : requestHistoryViewDisplay.UNSET,
        ...(idx === index ? prop : {}),
      }));
    },
    onOpenCloseHandler(index, row) {
      if (row.isOpen) {
        this.setActiveViewDisplay(requestHistoryViewDisplay.UNSET, index, {});
        this.results = this.results.map((x) => ({
          ...x,
          isOpen: false,
        }));
      } else {
        this.onOpenStatusHistoryHandler(index, row);
        this.results = this.results.map((x) => ({
          ...x,
          isOpen: true,
        }));
      }
    },
    async onOpenStatusHistoryHandler(
      index,
      { requestServiceId },
      pageIndex = 1,
      pageSize = DEFAULT_HISTORY_STATUS_PAGE_SIZE
    ) {
      if (requestServiceId) {
        this.ShowWait();
        const response = await this.getRpStatusHistory(
          requestServiceId,
          pageIndex,
          pageSize
        );
        this.setActiveViewDisplay(
          requestHistoryViewDisplay.STATUS_HISTORY,
          index,
          { serviceStatusHistory: response }
        );
        this.HideWait();
      }
    },
    async onOpenChangeStatusHandler(status, serviceType, index, row) {
      row.reasons = await this.getReasonsByStatus(status, serviceType);
      const viewDisplay = this.getViewDisplayByStatus(status);
      this.setActiveViewDisplay(viewDisplay, index);
    },
    onOpenReturnToPreviousStatusHandler(index) {
      this.setActiveViewDisplay(
        requestHistoryViewDisplay.RETURN_TO_PREVIOUS_STATUS,
        index
      );
    },
    async getReasonsByStatus(status, serviceType) {
      if (serviceStatuses.Objetado === status || !this.reasons[status]) {
        this.ShowWait();
        const { data } = await getDeterminationReasons(status, serviceType);
        this.reasons[status] = data;
        this.HideWait();
      }
      return this.reasons[status];
    },
    async onStatusHistoryLoadMoreHandler(index, row) {
      const pageIndex = row.serviceStatusHistory.currentPage;
      const pageSize =
        row.serviceStatusHistory.count + DEFAULT_HISTORY_STATUS_PAGE_SIZE;

      this.onOpenStatusHistoryHandler(index, row, pageIndex, pageSize);
    },
    getViewDisplayByStatus(status) {
      const viewDisplay = {
        [serviceStatuses.Nuevo]: requestHistoryViewDisplay.UNSET,
        [serviceStatuses.Aprobado]: requestHistoryViewDisplay.APPROVE,
        [serviceStatuses.Objetado]: requestHistoryViewDisplay.OBJECT,
        [serviceStatuses.Cancelado]: requestHistoryViewDisplay.CANCEL,
      };
      return viewDisplay[status] || requestHistoryViewDisplay.UNSET;
    },
    async onGetDeterminationLetterHandler(row) {
      this.ShowWait();
      await _getDeterminationLetterReport({
        requestServiceId: row.requestServiceId,
        serviceTypeId: row.serviceTypeId,
        serviceStatusId: row.serviceStatusId,
        determinationReasonId: row.determinationReasonId,
        determinationReasonCategoryId: row.determinationReasonCategoryId,
      })
        .then((res) => generalApi.ConvertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
      this.HideWait();
    },
    async onGetRequestReportHandler(row) {
      this.ShowWait();
      await _getRequestReport(row.requestServiceId)
        .then((res) => generalApi.ConvertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
      this.HideWait();
    },
    async onRefreshHandler() {
      await this.onSearchHandler();
    },
    async onSaveDeterminationHandler() {
      await this.onRefreshHandler();
    },
    async getRpRequestDocuments(requestServiceId) {
      return (await _getRpRequestDocuments(requestServiceId)).data;
    },
    async onOpenRequestDocumentHandler(index, { requestId }) {
      if (requestId) {
        const response = await this.getRpRequestDocuments(requestId);
        this.setActiveViewDisplay(requestHistoryViewDisplay.DOCUMENT, index, {
          requestDocument: response,
        });
      }
    },
    onOpenBitacoraAddBlogHandler(index, { requestId }) {
      if (requestId) {
        this.setActiveViewDisplay(requestHistoryViewDisplay.BITACORA, index, {});
      }
    },
    onOpenBitacoraHistoryHandler(index, { requestId }) {
      if (requestId) {
        this.setActiveViewDisplay(requestHistoryViewDisplay.BITACORA_HISTORY, index, {});
      }
    },
    async onPrintHandler() {
      if (!this.filters.academicYear && !this.filters.sieOrSolicitude) {
        this.ShowToast(
          'Alerta',
          'Para descargar el informe es requerido al menos el año académico o el número de SIE.',
          'error'
        );
        return;
      }

      const params = { ...this.getFilterValues };
      await _getRequestServicesReport(params)
        .then((res) => generalApi.ConvertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async fetchCenters() {
      this.filters.center = null;
      this.filters.municipality = null;
      this.filters.school = null;
      this.filters.region = null;

      const academicYearId = (this.filters.academicYear || {}).id;

      if (academicYearId) {
        const { data } = await this.$ApiGet('api/location/centers', {
          academicYearId,
        });

        this.filterOptions.centers = data;

        if (data.length == 1) {
          this.filters.center = data[0];
          await this.onCenterChanged();
        }
      }
    },
    async onCenterChanged() {
      const academicYearId = (this.filters.academicYear || {}).id;
      const centerId = (this.filters.center || {}).id;

      this.filters.municipality = null;
      this.filters.school = null;
      this.filters.region = null;

      if (academicYearId && centerId) {
        const { data } = await this.$ApiGet('api/location/municipalities', {
          academicYearId,
          centerId,
        });

        this.filterOptions.municipalities = data;

        if (data.length == 1) {
          this.filters.municipality = data[0];
          await this.onMunicipalityChanged();
        }
      }
    },
    async onMunicipalityChanged() {
      const academicYearId = (this.filters.academicYear || {}).id;
      const municipalityId = (this.filters.municipality || {}).id;

      this.filters.school = null;

      if (academicYearId && municipalityId) {
        const { data } = await this.$ApiGet('api/location/schools/', {
          academicYearId,
          municipalityId,
        });

        this.filterOptions.schools = data;

        if (data.length == 1) {
          this.filters.school = data[0];
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.alert-container {
  background-color: #fef5e8 !important;
  em,
  div {
    color: #b0690b;
  }
}
</style>
